'use strict';

let messages_it = {

  "HEADER": {
    "LOGOUT": "Logout"
  },

  "EXAMPLES": {
    "TODO_LIST.VISIBILITY_FILTER": {
      "SHOW_ALL": "All",
      "SHOW_COMPLETED": "Completed",
      "SHOW_ACTIVE": "Active"
    },
  },
  "FECON_ISAC": {
    "FUN_ACCOUNT": {
      "TITLE": "Account"
    },
    "FUN_LOGIN": {
      "TITLE": "Login"
    },
    "FUN_PWGONE": {
      "TITLE": "Credentials Recovery"
    },
    "FUN_PWLOCK": {
      "TITLE": "Credentials Recovery"
    },
    "FUN_PWFORGOT": {
      "TITLE": "Credentials Recovery"
    },
    "FUN_SECINFO": {
      "TITLE": "Security Info"
    },
    "FUN_FORCEEMAIL": {
      "TITLE": "Credentials Recovery"
    }
  }


};

export default messages_it;



// WEBPACK FOOTER //
// ./client/app/i18n/messages_en.js